import './status-tooltip.scss';

import { Tooltip } from 'antd';
import { type FC, type ReactNode } from 'react';

type TStatusTooltipProps = {
  title: string;
  titleChildren?: ReactNode;
  children?: ReactNode;
  textColor?: string;
};

const StatusTooltip: FC<TStatusTooltipProps> = ({
  title,
  titleChildren,
  children,
  textColor
}) => {
  return (
    <Tooltip
      title={
        <div className="status-tooltip__title-wrapper">
          <h2 style={{ color: textColor }} className="status-tooltip__title">
            {title}
          </h2>
          {titleChildren}
        </div>
      }
      destroyOnHidden
    >
      {children}
    </Tooltip>
  );
};

export default StatusTooltip;
